import { addDays } from 'date-fns'
import { z } from 'zod'
import { performanceSchema } from '~/schemas'
import { fetchApi } from './helpers'

export const fetchPerformancesData = async ({
  productId,
}: {
  productId: string
}) => {
  const tomorrow = addDays(new Date(), 1).toISOString().split('T')[0]
  const perPage = 100;

  let total: number = 0,
    items: any = [],
    response: any,
    offset: number = 0;

  do {
    response = await fetchApi(`/products/${productId}/performances`, {
      query: {
        'search[from_date]': tomorrow,
        limit: perPage,
        offset: offset,
      },
    });

    if (offset === 0) {
      total = z.number().parse(response.total);
    }

    items = items.concat(z.array(performanceSchema).parse(
      response.items?.map((item: Record<string, any>) => ({
        id: item.data?.id,
        externalId: item.data?.external_id,
        dateTime: item.data?.datetime,
      })),
    ));
    offset += perPage;

  } while (response.items.length === perPage || items.length < total);

  return { items, total }
}

export type PerformancesData = Awaited<ReturnType<typeof fetchPerformancesData>>
